import script from "./AdditionGame.vue?vue&type=script&setup=true&lang=js"
export * from "./AdditionGame.vue?vue&type=script&setup=true&lang=js"

import "./AdditionGame.vue?vue&type=style&index=0&id=5d13ae42&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d13ae42"]])

export default __exports__